import { useMyForm } from '../../../../../../../react-commons/hooks/useMyForm';
import { ResourceType } from '../../../../../resource/enumerations/ResourceType';
import {
    defaultToolResource,
    ToolMutationResourceSchema,
    type ToolResource,
    useToolActions,
} from '../../../../../resource/resources/artifacts/tool/toolResource';
import { EditChildBaseDialog } from '../../../../reusable-components/dialogs/EditChildBaseDialog';
import { Form_DisplayComponentBaseView } from '../../../../reusable-components/form-components/Form_DisplayComponentBaseView';
import { creationDialogOnSuccess } from '../../../../util/utilFunctions';
import { ToolContent } from './ToolContent';

export const ToolCreationDialog = ({
    onClose,
    parentId,
    autoGeneratedProps,
    onCreated,
}: {
    onClose: () => void;
    parentId: string;
    autoGeneratedProps?: ToolResource;
    onCreated?: (id: string, objectId: string) => void;
}) => {
    const toolActions = useToolActions();
    const addTool = toolActions.useAddResource();

    const { form, formNames, onSubmit } = useMyForm({
        schema: ToolMutationResourceSchema,
        defaultValues: {
            ...defaultToolResource,
            ...autoGeneratedProps,
        },
        submitHandler: async (data) => {
            await addTool.mutateAsync(
                {
                    resource: data,
                    parentId,
                },
                {
                    onSuccess: creationDialogOnSuccess(onCreated, onClose),
                }
            );
        },
    });

    return (
        <EditChildBaseDialog
            onClose={onClose}
            edited={form.formState.isDirty}
            title={'Create Tool'}
            resourceType={ResourceType.TOOL}
        >
            <Form_DisplayComponentBaseView onSubmit={onSubmit} form={form} canSubmitDefaultValue={true}>
                <ToolContent form={form} formNames={formNames} readOnly={false} />
            </Form_DisplayComponentBaseView>
        </EditChildBaseDialog>
    );
};
